<template>
  <div ref="whole_page">

      <course-viewer-quiz :isCardActive="true"
                        :quiz="quiz"
                        :taskIdProp="quiz.id"
                        :cardHeight="backgroundCardHeight"
                        :cardWidth="backgroundCardWidth"
                        :uuid="uuid"
                        @nextTask="nextTask"
                        @finishQuiz="quizFinished"
                        :key="index"
                        :isStudentProp="true"
                        :logData="logData"
                        :resetQuizButtons="resetQuizButtons"
                        :timeCapture="{}"
                        />

  </div>
</template>
<script>
  import CourseViewerQuiz from '@/components/courseviewer/CourseViewerQuiz.vue';
  import { uuid } from 'vue-uuid';

  export default {
    components: {
      CourseViewerQuiz
    },
    data() {
      return {
        backgroundCardHeight: "",
        backgroundCardWidth: "",
        uuid: "",
        quiz: {},
        logData: {},
        index: 0,
        isQuizFinished: false,
        popupXBtnClicked: false,
        taskId: 0,
        moduleId: 0,
        resetQuizButtons: false,
      }
    },
    watch: {
      popupXBtnClicked: function(val) {
        var self = this;
        if(val && !self.isQuizFinished) {
          var payload = {
            logIdentifier: self.uuid,
            toTaskId: null,
            fromTaskId: null,
            taskId: self.quizProp.id
          };
          self.$emit("postEndLog", payload);
        }
        else if(val && self.isQuizFinished) {
          self.$emit("refreshTasks");
        }
      }
    },
    methods: {
      showQuiz() {
        var self = this;
        self.isQuizFinished = false;
        if (self.quiz) {
          //Check if on mobile
          if (self.isMobile() && self.quiz.isDecisive) {
            self.$vs.dialog({
              type: "confirm",
              color: "warning",
              title: "Mobile Device Detected",
              text: "Unfortunately this quiz cannot be completed on a mobile device (smartphone or tablet).\n\nPlease log in again from a computer (laptop or desktop-computer).",
              accept: self.closePopup,
              acceptText: "Close",
              cancel: self.closePopup
            });
            return;
          }

          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.quiz.id;
          self.logData.logIdentifier = self.uuid;
        }
      },
      nextTask(){
        var self = this;
        var selectedInfo = JSON.parse(localStorage.getItem("selectedData"));
        if(localStorage.getItem("selectedData"))
          self.$router.push({ name: 'BrowseContent' , params: { selectedData: selectedInfo , navFromLesson: true}})
        else
          self.$router.push({ name: 'BrowseContent'});
      },
      resizeCard() {
        var ratio = 0.434;

        if ((window.innerWidth * 0.9) < 1555.55)
          this.backgroundCardWidth = window.innerWidth * 0.9;
        else
          this.backgroundCardWidth = 1555.55 * 0.9;

        this.backgroundCardHeight = this.backgroundCardWidth * ratio;
      },
      quizFinished(quizResults) {
        var self = this;

        if (quizResults) {
          self.logData.fromTaskId = null;
          self.logData.toTaskId = null;

          var onSuccess = function (response) {};

          var payload = {
            logIdentifier: self.logData.logIdentifier,
            toTaskId: null,
            fromTaskId: null,
            taskId:self.logData.taskId,
            taskId: quizResults.quizId,
          };

          self.$ajaxPost(self, "QuizTask/EndLogEntry", payload, onSuccess);

          self.isQuizFinished = true;
        }
      },
      closePopup() {
        this.$emit("closePopup")
      },

    },
    mounted() {
      var self = this;
      self.$nextTick(() => {
        window.addEventListener("resize", () => {
          self.resizeCard();
        });
      });
    },
    created() {
      var self = this;

      self.taskId = self.$route.params.taskId;
      self.moduleId = self.$route.params.moduleId;
      self.quiz = self.$route.params.quiz;
      self.quiz.standalone = true;

      self.$store.dispatch("updateTheme", "light");

      self.showQuiz();      
      self.index++;
      this.resizeCard();
    },
    beforeDestroy() {
      this.$store.dispatch("updateTheme", "dark");
    }
  }
</script>
<style lang="scss">
  #quizViewPopup div.vs-popup {
    width: 100%;
    height: 100%;

    .vs-popup--content {
      max-height: none;
    }
  }
  .vx-row{
      margin: 0;
      
  }
  .overflow-x-scroll{
    overflow-x: auto !important;
    padding-bottom: 20px;
  }
  .ag-center-cols-container{
      width: 100% !important;
  }

  .quizCard{
    width: 100% !important;
    height: 100% !important;
  }

</style>